// Array of Font Awesome classes (the "visual" name of the icon)
export const icons = [
  { icon: "fas fa-glass-martini" },
  { icon: "fas fa-music" },
  { icon: "fas fa-search" },
  { icon: "fas fa-heart" },
  { icon: "fas fa-star" },
  { icon: "fas fa-user" },
  { icon: "fas fa-film" },
  { icon: "fas fa-th-large" },
  { icon: "fas fa-th" },
  { icon: "fas fa-th-list" },
  { icon: "fas fa-check" },
  { icon: "fas fa-times" },
  { icon: "fas fa-search-plus" },
  { icon: "fas fa-search-minus" },
  { icon: "fas fa-power-off" },
  { icon: "fas fa-signal" },
  { icon: "fas fa-cog" },
  { icon: "fas fa-home" },
  { icon: "fas fa-clock" },
  { icon: "fas fa-road" },
  { icon: "fas fa-download" },
  { icon: "fas fa-inbox" },
  { icon: "fas fa-redo" },
  { icon: "fas fa-sync" },
  { icon: "fas fa-list-alt" },
  { icon: "fas fa-lock" },
  { icon: "fas fa-flag" },
  { icon: "fas fa-headphones" },
  { icon: "fas fa-volume-off" },
  { icon: "fas fa-volume-down" },
  { icon: "fas fa-volume-up" },
  { icon: "fas fa-qrcode" },
  { icon: "fas fa-barcode" },
  { icon: "fas fa-tag" },
  { icon: "fas fa-tags" },
  { icon: "fas fa-book" },
  { icon: "fas fa-bookmark" },
  { icon: "fas fa-print" },
  { icon: "fas fa-camera" },
  { icon: "fas fa-font" },
  { icon: "fas fa-bold" },
  { icon: "fas fa-italic" },
  { icon: "fas fa-text-height" },
  { icon: "fas fa-text-width" },
  { icon: "fas fa-align-left" },
  { icon: "fas fa-align-center" },
  { icon: "fas fa-align-right" },
  { icon: "fas fa-align-justify" },
  { icon: "fas fa-list" },
  { icon: "fas fa-outdent" },
  { icon: "fas fa-indent" },
  { icon: "fas fa-video" },
  { icon: "fas fa-image" },
  { icon: "fas fa-map-marker" },
  { icon: "fas fa-adjust" },
  { icon: "fas fa-tint" },
  { icon: "fas fa-edit" },
  { icon: "fas fa-step-backward" },
  { icon: "fas fa-fast-backward" },
  { icon: "fas fa-backward" },
  { icon: "fas fa-play" },
  { icon: "fas fa-pause" },
  { icon: "fas fa-stop" },
  { icon: "fas fa-forward" },
  { icon: "fas fa-fast-forward" },
  { icon: "fas fa-step-forward" },
  { icon: "fas fa-eject" },
  { icon: "fas fa-chevron-left" },
  { icon: "fas fa-chevron-right" },
  { icon: "fas fa-plus-circle" },
  { icon: "fas fa-minus-circle" },
  { icon: "fas fa-times-circle" },
  { icon: "fas fa-check-circle" },
  { icon: "fas fa-question-circle" },
  { icon: "fas fa-info-circle" },
  { icon: "fas fa-crosshairs" },
  { icon: "fas fa-ban" },
  { icon: "fas fa-arrow-left" },
  { icon: "fas fa-arrow-right" },
  { icon: "fas fa-arrow-up" },
  { icon: "fas fa-arrow-down" },
  { icon: "fas fa-share" },
  { icon: "fas fa-expand" },
  { icon: "fas fa-compress" },
  { icon: "fas fa-plus" },
  { icon: "fas fa-minus" },
  { icon: "fas fa-asterisk" },
  { icon: "fas fa-exclamation-circle" },
  { icon: "fas fa-gift" },
  { icon: "fas fa-leaf" },
  { icon: "fas fa-fire" },
  { icon: "fas fa-eye" },
  { icon: "fas fa-eye-slash" },
  { icon: "fas fa-exclamation-triangle" },
  { icon: "fas fa-plane" },
  { icon: "fas fa-calendar-alt" },
  { icon: "fas fa-random" },
  { icon: "fas fa-comment" },
  { icon: "fas fa-magnet" },
  { icon: "fas fa-chevron-up" },
  { icon: "fas fa-chevron-down" },
  { icon: "fas fa-retweet" },
  { icon: "fas fa-shoppingcart" },
  { icon: "fas fa-folder" },
  { icon: "fas fa-folder-open" },
  { icon: "fas fa-chart-bar" },
  { icon: "fas fa-camera-retro" },
  { icon: "fas fa-key" },
  { icon: "fas fa-cogs" },
  { icon: "fas fa-comments" },
  { icon: "fas fa-star-half" },
  { icon: "fas fa-thumbtack" },
  { icon: "fas fa-trophy" },
  { icon: "fas fa-upload" },
  { icon: "fas fa-lemon" },
  { icon: "fas fa-phone" },
  { icon: "fas fa-phone-square" },
  { icon: "fas fa-unlock" },
  { icon: "fas fa-credit-card" },
  { icon: "fas fa-rss" },
  { icon: "fas fa-hdd" },
  { icon: "fas fa-bullhorn" },
  { icon: "fas fa-certificate" },
  { icon: "fas fa-hand-point-right" },
  { icon: "fas fa-hand-point-left" },
  { icon: "fas fa-hand-point-up" },
  { icon: "fas fa-hand-point-down" },
  { icon: "fas fa-arrow-circle-left" },
  { icon: "fas fa-arrow-circle-right" },
  { icon: "fas fa-arrow-circle-up" },
  { icon: "fas fa-arrow-circle-down" },
  { icon: "fas fa-globe" },
  { icon: "fas fa-wrench" },
  { icon: "fas fa-tasks" },
  { icon: "fas fa-filter" },
  { icon: "fas fa-briefcase" },
  { icon: "fas fa-arrows-alt" },
  { icon: "fas fa-users" },
  { icon: "fas fa-link" },
  { icon: "fas fa-cloud" },
  { icon: "fas fa-flask" },
  { icon: "fas fa-cut" },
  { icon: "fas fa-copy" },
  { icon: "fas fa-paperclip" },
  { icon: "fas fa-save" },
  { icon: "fas fa-square" },
  { icon: "fas fa-bars" },
  { icon: "fas fa-list-ul" },
  { icon: "fas fa-list-ol" },
  { icon: "fas fa-strikethrough" },
  { icon: "fas fa-underline" },
  { icon: "fas fa-table" },
  { icon: "fas fa-magic" },
  { icon: "fas fa-truck" },
  { icon: "fas fa-money-bill" },
  { icon: "fas fa-caret-down" },
  { icon: "fas fa-caret-up" },
  { icon: "fas fa-caret-left" },
  { icon: "fas fa-caret-right" },
  { icon: "fas fa-columns" },
  { icon: "fas fa-sort" },
  { icon: "fas fa-sort-down" },
  { icon: "fas fa-sort-up" },
  { icon: "fas fa-envelope" },
  { icon: "fas fa-undo" },
  { icon: "fas fa-gavel" },
  { icon: "fas fa-bolt" },
  { icon: "fas fa-sitemap" },
  { icon: "fas fa-umbrella" },
  { icon: "fas fa-paste" },
  { icon: "fas fa-lightbulb" },
  { icon: "fas fa-usermd" },
  { icon: "fas fa-stethoscope" },
  { icon: "fas fa-suitcase" },
  { icon: "fas fa-bell" },
  { icon: "fas fa-coffee" },
  { icon: "fas fa-hospital" },
  { icon: "fas fa-ambulance" },
  { icon: "fas fa-medkit" },
  { icon: "fas fa-fighter-jet" },
  { icon: "fas fa-beer" },
  { icon: "fas fa-h-square" },
  { icon: "fas fa-plus-square" },
  { icon: "fas fa-angle-double-left" },
  { icon: "fas fa-angle-double-right" },
  { icon: "fas fa-angle-double-up" },
  { icon: "fas fa-angle-double-down" },
  { icon: "fas fa-angle-left" },
  { icon: "fas fa-angle-right" },
  { icon: "fas fa-angle-up" },
  { icon: "fas fa-angle-down" },
  { icon: "fas fa-desktop" },
  { icon: "fas fa-laptop" },
  { icon: "fas fa-tablet" },
  { icon: "fas fa-mobile" },
  { icon: "fas fa-quoteleft" },
  { icon: "fas fa-quoteright" },
  { icon: "fas fa-spinner" },
  { icon: "fas fa-circle" },
  { icon: "fas fa-smile" },
  { icon: "fas fa-frown" },
  { icon: "fas fa-meh" },
  { icon: "fas fa-gamepad" },
  { icon: "fas fa-keyboard" },
  { icon: "fas fa-flag-checkered" },
  { icon: "fas fa-terminal" },
  { icon: "fas fa-code" },
  { icon: "fas fa-replyall" },
  { icon: "fas fa-location-arrow" },
  { icon: "fas fa-crop" },
  { icon: "fas fa-code-branch" },
  { icon: "fas fa-unlink" },
  { icon: "fas fa-question" },
  { icon: "fas fa-info" },
  { icon: "fas fa-exclamation" },
  { icon: "fas fa-superscript" },
  { icon: "fas fa-subscript" },
  { icon: "fas fa-eraser" },
  { icon: "fas fa-puzzle-piece" },
  { icon: "fas fa-microphone" },
  { icon: "fas fa-microphone-slash" },
  { icon: "fas fa-calendar" },
  { icon: "fas fa-fire-extinguisher" },
  { icon: "fas fa-rocket" },
  { icon: "fas fa-chevron-circle-left" },
  { icon: "fas fa-chevron-circle-right" },
  { icon: "fas fa-chevron-circle-up" },
  { icon: "fas fa-chevron-circle-down" },
  { icon: "fas fa-anchor" },
  { icon: "fas fa-unlock-alt" },
  { icon: "fas fa-bullseye" },
  { icon: "fas fa-ellipsis-h" },
  { icon: "fas fa-ellipsis-v" },
  { icon: "fas fa-rss-square" },
  { icon: "fas fa-play-circle" },
  { icon: "fas fa-minus-square" },
  { icon: "fas fa-check-square" },
  { icon: "fas fa-pens-quare" },
  { icon: "fas fa-share-square" },
  { icon: "fas fa-compass" },
  { icon: "fas fa-caret-square-down" },
  { icon: "fas fa-caret-square-up" },
  { icon: "fas fa-caret-square-right" },
  { icon: "fas fa-euro-sign" },
  { icon: "fas fa-pound-sign" },
  { icon: "fas fa-dollar-sign" },
  { icon: "fas fa-rupee-sign" },
  { icon: "fas fa-yen-sign" },
  { icon: "fas fa-ruble-sign" },
  { icon: "fas fa-won-sign" },
  { icon: "fas fa-file" },
  { icon: "fas fa-file-alt" },
  { icon: "fas fa-sort-alpha-down" },
  { icon: "fas fa-sort-alpha-up" },
  { icon: "fas fa-sort-amount-down" },
  { icon: "fas fa-sort-amount-up" },
  { icon: "fas fa-sort-numeric-down" },
  { icon: "fas fa-sort-numeric-up" },
  { icon: "fas fa-thumbs-up" },
  { icon: "fas fa-thumbs-down" },
  { icon: "fas fa-female" },
  { icon: "fas fa-male" },
  { icon: "fas fa-sun" },
  { icon: "fas fa-moon" },
  { icon: "fas fa-archive" },
  { icon: "fas fa-bug" },
  { icon: "fas fa-caret-square-left" },
  { icon: "fas fa-dot-circle" },
  { icon: "fas fa-wheelchair" },
  { icon: "fas fa-lira-sign" },
  { icon: "fas fa-space-shuttle" },
  { icon: "fas fa-envelope-square" },
  { icon: "fas fa-university" },
  { icon: "fas fa-graduation-cap" },
  { icon: "fas fa-language" },
  { icon: "fas fa-fax" },
  { icon: "fas fa-building" },
  { icon: "fas fa-child" },
  { icon: "fas fa-paw" },
  { icon: "fas fa-cube" },
  { icon: "fas fa-cubes" },
  { icon: "fas fa-recycle" },
  { icon: "fas fa-car" },
  { icon: "fas fa-taxi" },
  { icon: "fas fa-tree" },
  { icon: "fas fa-database" },
  { icon: "fas fa-file-pdf" },
  { icon: "fas fa-file-word" },
  { icon: "fas fa-file-excel" },
  { icon: "fas fa-file-powerpoint" },
  { icon: "fas fa-file-image" },
  { icon: "fas fa-file-archive" },
  { icon: "fas fa-file-audio" },
  { icon: "fas fa-file-video" },
  { icon: "fas fa-file-code" },
  { icon: "fas fa-life-ring" },
  { icon: "fas fa-circle-notch" },
  { icon: "fas fa-paper-plane" },
  { icon: "fas fa-history" },
  { icon: "fas fa-heading" },
  { icon: "fas fa-paragraph" },
  { icon: "fas fa-sliders-h" },
  { icon: "fas fa-share-alt" },
  { icon: "fas fa-share-alt-square" },
  { icon: "fas fa-bomb" },
  { icon: "fas fa-futbol" },
  { icon: "fas fa-tty" },
  { icon: "fas fa-binoculars" },
  { icon: "fas fa-plug" },
  { icon: "fas fa-newspaper" },
  { icon: "fas fa-wifi" },
  { icon: "fas fa-calculator" },
  { icon: "fas fa-bell-slash" },
  { icon: "fas fa-trash" },
  { icon: "fas fa-copyright" },
  { icon: "fas fa-at" },
  { icon: "fas fa-eye-dropper" },
  { icon: "fas fa-paint-brush" },
  { icon: "fas fa-birthday-cake" },
  { icon: "fas fa-chart-area" },
  { icon: "fas fa-chart-pie" },
  { icon: "fas fa-chart-line" },
  { icon: "fas fa-toggle-off" },
  { icon: "fas fa-toggle-on" },
  { icon: "fas fa-bicycle" },
  { icon: "fas fa-bus" },
  { icon: "fas fa-closed-captioning" },
  { icon: "fas fa-shekel-sign" },
  { icon: "fas fa-cart-plus" },
  { icon: "fas fa-cart-arrow-down" },
  { icon: "fas fa-ship" },
  { icon: "fas fa-user-secret" },
  { icon: "fas fa-motorcycle" },
  { icon: "fas fa-street-view" },
  { icon: "fas fa-heartbeat" },
  { icon: "fas fa-venus" },
  { icon: "fas fa-mars" },
  { icon: "fas fa-mercury" },
  { icon: "fas fa-transgender" },
  { icon: "fas fa-transgender-alt" },
  { icon: "fas fa-venus-double" },
  { icon: "fas fa-mars-double" },
  { icon: "fas fa-venus-mars" },
  { icon: "fas fa-mars-stroke" },
  { icon: "fas fa-mars-stroke-v" },
  { icon: "fas fa-mars-stroke-h" },
  { icon: "fas fa-neuter" },
  { icon: "fas fa-genderless" },
  { icon: "fas fa-server" },
  { icon: "fas fa-user-plus" },
  { icon: "fas fa-user-times" },
  { icon: "fas fa-bed" },
  { icon: "fas fa-train" },
  { icon: "fas fa-subway" },
  { icon: "fas fa-battery-full" },
  { icon: "fas fa-battery-threequarters" },
  { icon: "fas fa-battery-half" },
  { icon: "fas fa-battery-quarter" },
  { icon: "fas fa-battery-empty" },
  { icon: "fas fa-mouse-pointer" },
  { icon: "fas fa-i-cursor" },
  { icon: "fas fa-object-group" },
  { icon: "fas fa-object-ungroup" },
  { icon: "fas fa-sticky-note" },
  { icon: "fas fa-clone" },
  { icon: "fas fa-balance-scale" },
  { icon: "fas fa-hourglass-start" },
  { icon: "fas fa-hourglass-half" },
  { icon: "fas fa-hourglass-end" },
  { icon: "fas fa-hourglass" },
  { icon: "fas fa-hand-rock" },
  { icon: "fas fa-hand-paper" },
  { icon: "fas fa-hand-scissors" },
  { icon: "fas fa-hand-lizard" },
  { icon: "fas fa-hand-spock" },
  { icon: "fas fa-hand-pointer" },
  { icon: "fas fa-hand-peace" },
  { icon: "fas fa-trademark" },
  { icon: "fas fa-registered" },
  { icon: "fas fa-tv" },
  { icon: "fas fa-calendar-plus" },
  { icon: "fas fa-calendar-minus" },
  { icon: "fas fa-calendar-times" },
  { icon: "fas fa-calendar-check" },
  { icon: "fas fa-industry" },
  { icon: "fas fa-map-pin" },
  { icon: "fas fa-map-signs" },
  { icon: "fas fa-map" },
  { icon: "fas fa-comment-alt" },
  { icon: "fas fa-pause-circle" },
  { icon: "fas fa-stop-circle" },
  { icon: "fas fa-shopping-bag" },
  { icon: "fas fa-shopping-basket" },
  { icon: "fas fa-hashtag" },
  { icon: "fas fa-percent" },
  { icon: "fas fa-universal-access" },
  { icon: "fas fa-blind" },
  { icon: "fas fa-audio-description" },
  { icon: "fas fa-phone-volume" },
  { icon: "fas fa-braille" },
  { icon: "fas fa-assistive-listening-systems" },
  { icon: "fas fa-american-sign-language-interpreting" },
  { icon: "fas fa-deaf" },
  { icon: "fas fa-sign-language" },
  { icon: "fas fa-low-vision" },
  { icon: "fas fa-handshake" },
  { icon: "fas fa-envelope-open" },
  { icon: "fas fa-address-book" },
  { icon: "fas fa-address-card" },
  { icon: "fas fa-user-circle" },
  { icon: "fas fa-id-badge" },
  { icon: "fas fa-id-card" },
  { icon: "fas fa-thermometer-full" },
  { icon: "fas fa-thermometer-three-quarters" },
  { icon: "fas fa-thermometer-half" },
  { icon: "fas fa-thermometer-quarter" },
  { icon: "fas fa-thermometer-empty" },
  { icon: "fas fa-shower" },
  { icon: "fas fa-bath" },
  { icon: "fas fa-podcast" },
  { icon: "fas fa-window-maximize" },
  { icon: "fas fa-window-minimize" },
  { icon: "fas fa-window-restore" },
  { icon: "fas fa-microchip" },
  { icon: "fas fa-snowflake" },
  { icon: "fas fa-utensil-spoon" },
  { icon: "fas fa-utensils" },
  { icon: "fas fa-undo-alt" },
  { icon: "fas fa-trash-alt" },
  { icon: "fas fa-sync-alt" },
  { icon: "fas fa-stopwatch" },
  { icon: "fas fa-sign-out-alt" },
  { icon: "fas fa-sign-in-alt" },
  { icon: "fas fa-redo-alt" },
  { icon: "fas fa-poo" },
  { icon: "fas fa-images" },
  { icon: "fas fa-pencil-alt" },
  { icon: "fas fa-pen" },
  { icon: "fas fa-pen-alt" },
  { icon: "fas fa-long-arrow-alt-down" },
  { icon: "fas fa-long-arrow-alt-left" },
  { icon: "fas fa-long-arrow-alt-right" },
  { icon: "fas fa-long-arrow-alt-up" },
  { icon: "fas fa-expand-arrows-alt" },
  { icon: "fas fa-clipboard" },
  { icon: "fas fa-arrows-alt-h" },
  { icon: "fas fa-arrows-alt-v" },
  { icon: "fas fa-arrow-alt-circle-down" },
  { icon: "fas fa-arrow-alt-circle-left" },
  { icon: "fas fa-arrow-alt-circle-right" },
  { icon: "fas fa-arrow-alt-circle-up" },
  { icon: "fas fa-external-link-alt" },
  { icon: "fas fa-external-link-square-alt" },
  { icon: "fas fa-exchange-alt" },
  { icon: "fas fa-cloud-download-alt" },
  { icon: "fas fa-cloud-upload-alt" },
  { icon: "fas fa-gem" },
  { icon: "fas fa-level-down-alt" },
  { icon: "fas fa-level-up-alt" },
  { icon: "fas fa-lock-open" },
  { icon: "fas fa-map-marker-alt" },
  { icon: "fas fa-microphone-alt" },
  { icon: "fas fa-mobile-alt" },
  { icon: "fas fa-money-bill-alt" },
  { icon: "fas fa-phone-slash" },
  { icon: "fas fa-portrait" },
  { icon: "fas fa-reply" },
  { icon: "fas fa-shield-alt" },
  { icon: "fas fa-tablet-alt" },
  { icon: "fas fa-tachometer-alt" },
  { icon: "fas fa-ticket-alt" },
  { icon: "fas fa-user-alt" },
  { icon: "fas fa-window-close" },
  { icon: "fas fa-baseball-ball" },
  { icon: "fas fa-basketball-ball" },
  { icon: "fas fa-bowling-ball" },
  { icon: "fas fa-chess" },
  { icon: "fas fa-chess-bishop" },
  { icon: "fas fa-chess-board" },
  { icon: "fas fa-chess-king" },
  { icon: "fas fa-chess-knight" },
  { icon: "fas fa-chess-pawn" },
  { icon: "fas fa-chess-queen" },
  { icon: "fas fa-chess-rook" },
  { icon: "fas fa-dumbbell" },
  { icon: "fas fa-football-ball" },
  { icon: "fas fa-golf-ball" },
  { icon: "fas fa-hockey-puck" },
  { icon: "fas fa-quidditch" },
  { icon: "fas fa-square-full" },
  { icon: "fas fa-table-tennis" },
  { icon: "fas fa-volleyball-ball" },
  { icon: "fas fa-allergies" },
  { icon: "fas fa-band-aid" },
  { icon: "fas fa-box" },
  { icon: "fas fa-boxes" },
  { icon: "fas fa-briefcase-medical" },
  { icon: "fas fa-burn" },
  { icon: "fas fa-capsules" },
  { icon: "fas fa-clipboard-check" },
  { icon: "fas fa-clipboard-list" },
  { icon: "fas fa-diagnoses" },
  { icon: "fas fa-dna" },
  { icon: "fas fa-dolly" },
  { icon: "fas fa-dolly-flatbed" },
  { icon: "fas fa-file-medical" },
  { icon: "fas fa-file-medical-alt" },
  { icon: "fas fa-first-aid" },
  { icon: "fas fa-hospital-alt" },
  { icon: "fas fa-hospital-symbol" },
  { icon: "fas fa-id-card-alt" },
  { icon: "fas fa-notes-medical" },
  { icon: "fas fa-pallet" },
  { icon: "fas fa-pills" },
  { icon: "fas fa-prescription-bottle" },
  { icon: "fas fa-prescription-bottle-alt" },
  { icon: "fas fa-procedures" },
  { icon: "fas fa-shipping-fast" },
  { icon: "fas fa-smoking" },
  { icon: "fas fa-syringe" },
  { icon: "fas fa-tablets" },
  { icon: "fas fa-thermometer" },
  { icon: "fas fa-vial" },
  { icon: "fas fa-vials" },
  { icon: "fas fa-warehouse" },
  { icon: "fas fa-weight" },
  { icon: "fas fa-x-ray" },
  { icon: "fas fa-box-open" },
  { icon: "fas fa-comment-dots" },
  { icon: "fas fa-comment-slash" },
  { icon: "fas fa-couch" },
  { icon: "fas fa-donate" },
  { icon: "fas fa-dove" },
  { icon: "fas fa-hand-holding" },
  { icon: "fas fa-hand-holding-heart" },
  { icon: "fas fa-hand-holding-usd" },
  { icon: "fas fa-hands" },
  { icon: "fas fa-hands-helping" },
  { icon: "fas fa-parachute-box" },
  { icon: "fas fa-people-carry" },
  { icon: "fas fa-piggy-bank" },
  { icon: "fas fa-ribbon" },
  { icon: "fas fa-route" },
  { icon: "fas fa-seedling" },
  { icon: "fas fa-sign" },
  { icon: "fas fa-smile-wink" },
  { icon: "fas fa-tape" },
  { icon: "fas fa-truck-loading" },
  { icon: "fas fa-truck-moving" },
  { icon: "fas fa-video-slash" },
  { icon: "fas fa-wine-glass" },
  { icon: "fas fa-user-alt-slash" },
  { icon: "fas fa-user-astronaut" },
  { icon: "fas fa-user-check" },
  { icon: "fas fa-user-clock" },
  { icon: "fas fa-user-cog" },
  { icon: "fas fa-user-edit" },
  { icon: "fas fa-user-friends" },
  { icon: "fas fa-user-graduate" },
  { icon: "fas fa-user-lock" },
  { icon: "fas fa-user-minus" },
  { icon: "fas fa-user-ninja" },
  { icon: "fas fa-user-shield" },
  { icon: "fas fa-user-slash" },
  { icon: "fas fa-user-tag" },
  { icon: "fas fa-user-tie" },
  { icon: "fas fa-users-cog" },
  { icon: "fas fa-balance-scale-left" },
  { icon: "fas fa-balance-scale-right" },
  { icon: "fas fa-blender" },
  { icon: "fas fa-bookopen" },
  { icon: "fas fa-broadcast-tower" },
  { icon: "fas fa-broom" },
  { icon: "fas fa-chalkboard" },
  { icon: "fas fa-chalkboard-teacher" },
  { icon: "fas fa-church" },
  { icon: "fas fa-coins" },
  { icon: "fas fa-compact-disc" },
  { icon: "fas fa-crow" },
  { icon: "fas fa-crown" },
  { icon: "fas fa-dice" },
  { icon: "fas fa-dice-five" },
  { icon: "fas fa-dice-four" },
  { icon: "fas fa-dice-one" },
  { icon: "fas fa-dice-six" },
  { icon: "fas fa-dice-three" },
  { icon: "fas fa-dice-two" },
  { icon: "fas fa-divide" },
  { icon: "fas fa-door-closed" },
  { icon: "fas fa-door-open" },
  { icon: "fas fa-equals" },
  { icon: "fas fa-feather" },
  { icon: "fas fa-frog" },
  { icon: "fas fa-gas-pump" },
  { icon: "fas fa-glasses" },
  { icon: "fas fa-greater-than" },
  { icon: "fas fa-greater-than-equal" },
  { icon: "fas fa-helicopter" },
  { icon: "fas fa-infinity" },
  { icon: "fas fa-kiwibird" },
  { icon: "fas fa-less-than" },
  { icon: "fas fa-less-than-equal" },
  { icon: "fas fa-memory" },
  { icon: "fas fa-microphone-alt-slash" },
  { icon: "fas fa-money-bill-wave" },
  { icon: "fas fa-money-bill-wave-alt" },
  { icon: "fas fa-money-check" },
  { icon: "fas fa-money-check-alt" },
  { icon: "fas fa-not-equal" },
  { icon: "fas fa-palette" },
  { icon: "fas fa-parking" },
  { icon: "fas fa-percentage" },
  { icon: "fas fa-project-diagram" },
  { icon: "fas fa-receipt" },
  { icon: "fas fa-robot" },
  { icon: "fas fa-ruler" },
  { icon: "fas fa-ruler-combined" },
  { icon: "fas fa-ruler-horizontal" },
  { icon: "fas fa-ruler-vertical" },
  { icon: "fas fa-school" },
  { icon: "fas fa-screwdriver" },
  { icon: "fas fa-shoe-prints" },
  { icon: "fas fa-skull" },
  { icon: "fas fa-smoking-ban" },
  { icon: "fas fa-store" },
  { icon: "fas fa-store-alt" },
  { icon: "fas fa-stream" },
  { icon: "fas fa-stroopwafel" },
  { icon: "fas fa-toolbox" },
  { icon: "fas fa-tshirt" },
  { icon: "fas fa-walking" },
  { icon: "fas fa-wallet" },
  { icon: "fas fa-angry" },
  { icon: "fas fa-archway" },
  { icon: "fas fa-atlas" },
  { icon: "fas fa-award" },
  { icon: "fas fa-backspace" },
  { icon: "fas fa-bezier-curve" },
  { icon: "fas fa-bong" },
  { icon: "fas fa-brush" },
  { icon: "fas fa-bus-alt" },
  { icon: "fas fa-cannabis" },
  { icon: "fas fa-check-double" },
  { icon: "fas fa-cocktail" },
  { icon: "fas fa-concierge-bell" },
  { icon: "fas fa-cookie" },
  { icon: "fas fa-cookie-bite" },
  { icon: "fas fa-crop-alt" },
  { icon: "fas fa-digital-tachograph" },
  { icon: "fas fa-dizzy" },
  { icon: "fas fa-drafting-compass" },
  { icon: "fas fa-drum" },
  { icon: "fas fa-drum-steelpan" },
  { icon: "fas fa-feather-alt" },
  { icon: "fas fa-file-contract" },
  { icon: "fas fa-file-download" },
  { icon: "fas fa-file-export" },
  { icon: "fas fa-file-import" },
  { icon: "fas fa-file-invoice" },
  { icon: "fas fa-file-invoice-dollar" },
  { icon: "fas fa-file-prescription" },
  { icon: "fas fa-file-signature" },
  { icon: "fas fa-file-upload" },
  { icon: "fas fa-fill" },
  { icon: "fas fa-fill-drip" },
  { icon: "fas fa-fingerprint" },
  { icon: "fas fa-fish" },
  { icon: "fas fa-flushed" },
  { icon: "fas fa-frown-open" },
  { icon: "fas fa-glass-martini-alt" },
  { icon: "fas fa-globe-africa" },
  { icon: "fas fa-globe-americas" },
  { icon: "fas fa-globe-asia" },
  { icon: "fas fa-grimace" },
  { icon: "fas fa-grin" },
  { icon: "fas fa-grin-alt" },
  { icon: "fas fa-grin-beam" },
  { icon: "fas fa-grin-beam-sweat" },
  { icon: "fas fa-grin-hearts" },
  { icon: "fas fa-grin-squint" },
  { icon: "fas fa-grin-squint-tears" },
  { icon: "fas fa-grin-stars" },
  { icon: "fas fa-grin-tears" },
  { icon: "fas fa-grin-tongue" },
  { icon: "fas fa-grin-tongue-squint" },
  { icon: "fas fa-grin-tongue-wink" },
  { icon: "fas fa-grin-wink" },
  { icon: "fas fa-grip-horizontal" },
  { icon: "fas fa-grip-vertical" },
  { icon: "fas fa-headphones-alt" },
  { icon: "fas fa-headset" },
  { icon: "fas fa-highlighter" },
  { icon: "fas fa-hot-tub" },
  { icon: "fas fa-hotel" },
  { icon: "fas fa-joint" },
  { icon: "fas fa-kiss" },
  { icon: "fas fa-kiss-beam" },
  { icon: "fas fa-kiss-wink-heart" },
  { icon: "fas fa-laugh" },
  { icon: "fas fa-laugh-beam" },
  { icon: "fas fa-laugh-squint" },
  { icon: "fas fa-laugh-wink" },
  { icon: "fas fa-luggage-cart" },
  { icon: "fas fa-map-marked" },
  { icon: "fas fa-map-marked-alt" },
  { icon: "fas fa-marker" },
  { icon: "fas fa-medal" },
  { icon: "fas fa-meh-blank" },
  { icon: "fas fa-meh-rolling-eyes" },
  { icon: "fas fa-monument" },
  { icon: "fas fa-mortar-pestle" },
  { icon: "fas fa-paint-roller" },
  { icon: "fas fa-passport" },
  { icon: "fas fa-pen-fancy" },
  { icon: "fas fa-pen-nib" },
  { icon: "fas fa-pencil-ruler" },
  { icon: "fas fa-plane-arrival" },
  { icon: "fas fa-plane-departure" },
  { icon: "fas fa-prescription" },
  { icon: "fas fa-sad-cry" },
  { icon: "fas fa-sad-tear" },
  { icon: "fas fa-shuttle-van" },
  { icon: "fas fa-signature" },
  { icon: "fas fa-smile-beam" },
  { icon: "fas fa-solar-panel" },
  { icon: "fas fa-spa" },
  { icon: "fas fa-splotch" },
  { icon: "fas fa-spray-can" },
  { icon: "fas fa-stamp" },
  { icon: "fas fa-star-half-alt" },
  { icon: "fas fa-suitcase-rolling" },
  { icon: "fas fa-surprise" },
  { icon: "fas fa-swatchbook" },
  { icon: "fas fa-swimmer" },
  { icon: "fas fa-swimming-pool" },
  { icon: "fas fa-tint-slash" },
  { icon: "fas fa-tired" },
  { icon: "fas fa-tooth" },
  { icon: "fas fa-umbrella-beach" },
  { icon: "fas fa-vector-square" },
  { icon: "fas fa-weight-hanging" },
  { icon: "fas fa-wine-glass-alt" },
  { icon: "fas fa-air-freshener" },
  { icon: "fas fa-apple-alt" },
  { icon: "fas fa-atom" },
  { icon: "fas fa-bone" },
  { icon: "fas fa-book-reader" },
  { icon: "fas fa-brain" },
  { icon: "fas fa-car-alt" },
  { icon: "fas fa-car-battery" },
  { icon: "fas fa-car-crash" },
  { icon: "fas fa-car-side" },
  { icon: "fas fa-charging-station" },
  { icon: "fas fa-directions" },
  { icon: "fas fa-draw-polygon" },
  { icon: "fas fa-laptop-code" },
  { icon: "fas fa-layer-group" },
  { icon: "fas fa-microscope" },
  { icon: "fas fa-oil-can" },
  { icon: "fas fa-poop" },
  { icon: "fas fa-shapes" },
  { icon: "fas fa-star-of-life" },
  { icon: "fas fa-teeth" },
  { icon: "fas fa-teet-hopen" },
  { icon: "fas fa-theater-masks" },
  { icon: "fas fa-traffic-light" },
  { icon: "fas fa-truck-monster" },
  { icon: "fas fa-truck-pickup" },
  { icon: "fas fa-ad" },
  { icon: "fas fa-ankh" },
  { icon: "fas fa-bible" },
  { icon: "fas fa-business-time" },
  { icon: "fas fa-city" },
  { icon: "fas fa-comment-dollar" },
  { icon: "fas fa-comments-dollar" },
  { icon: "fas fa-cross" },
  { icon: "fas fa-dharmachakra" },
  { icon: "fas fa-envelope-open-text" },
  { icon: "fas fa-folder-minus" },
  { icon: "fas fa-folder-plus" },
  { icon: "fas fa-funnel-dollar" },
  { icon: "fas fa-gopuram" },
  { icon: "fas fa-hamsa" },
  { icon: "fas fa-haykal" },
  { icon: "fas fa-jedi" },
  { icon: "fas fa-journal-whills" },
  { icon: "fas fa-kaaba" },
  { icon: "fas fa-khanda" },
  { icon: "fas fa-landmark" },
  { icon: "fas fa-mail-bulk" },
  { icon: "fas fa-menorah" },
  { icon: "fas fa-mosque" },
  { icon: "fas fa-om" },
  { icon: "fas fa-pastafarianism" },
  { icon: "fas fa-peace" },
  { icon: "fas fa-place-of-worship" },
  { icon: "fas fa-poll" },
  { icon: "fas fa-poll-h" },
  { icon: "fas fa-pray" },
  { icon: "fas fa-praying-hands" },
  { icon: "fas fa-quran" },
  { icon: "fas fa-search-dollar" },
  { icon: "fas fa-search-location" },
  { icon: "fas fa-socks" },
  { icon: "fas fa-square-root-alt" },
  { icon: "fas fa-star-and-crescent" },
  { icon: "fas fa-star-of-david" },
  { icon: "fas fa-synagogue" },
  { icon: "fas fa-torah" },
  { icon: "fas fa-torii-gate" },
  { icon: "fas fa-vihara" },
  { icon: "fas fa-volume-mute" },
  { icon: "fas fa-yin-yang" },
  { icon: "fas fa-blender-phone" },
  { icon: "fas fa-book-dead" },
  { icon: "fas fa-campground" },
  { icon: "fas fa-cat" },
  { icon: "fas fa-chair" },
  { icon: "fas fa-cloud-moon" },
  { icon: "fas fa-cloud-sun" },
  { icon: "fas fa-dice-d20" },
  { icon: "fas fa-dice-d6" },
  { icon: "fas fa-dog" },
  { icon: "fas fa-dragon" },
  { icon: "fas fa-drumstick-bite" },
  { icon: "fas fa-dungeon" },
  { icon: "fas fa-file-csv" },
  { icon: "fas fa-fist-raised" },
  { icon: "fas fa-ghost" },
  { icon: "fas fa-hammer" },
  { icon: "fas fa-hanukiah" },
  { icon: "fas fa-hat-wizard" },
  { icon: "fas fa-hiking" },
  { icon: "fas fa-hippo" },
  { icon: "fas fa-horse" },
  { icon: "fas fa-house-damage" },
  { icon: "fas fa-hryvnia" },
  { icon: "fas fa-mask" },
  { icon: "fas fa-mountain" },
  { icon: "fas fa-network-wired" },
  { icon: "fas fa-otter" },
  { icon: "fas fa-ring" },
  { icon: "fas fa-running" },
  { icon: "fas fa-scroll" },
  { icon: "fas fa-skull-crossbones" },
  { icon: "fas fa-slash" },
  { icon: "fas fa-spider" },
  { icon: "fas fa-toilet-paper" },
  { icon: "fas fa-tractor" },
  { icon: "fas fa-user-injured" },
  { icon: "fas fa-vr-cardboard" },
  { icon: "fas fa-wind" },
  { icon: "fas fa-wine-bottle" },
  { icon: "fas fa-cloud-meatball" },
  { icon: "fas fa-cloud-moon-rain" },
  { icon: "fas fa-cloud-rain" },
  { icon: "fas fa-cloud-showers-heavy" },
  { icon: "fas fa-cloud-sun-rain" },
  { icon: "fas fa-democrat" },
  { icon: "fas fa-flag-usa" },
  { icon: "fas fa-meteor" },
  { icon: "fas fa-person-booth" },
  { icon: "fas fa-poo-storm" },
  { icon: "fas fa-rainbow" },
  { icon: "fas fa-republican" },
  { icon: "fas fa-smog" },
  { icon: "fas fa-temperature-high" },
  { icon: "fas fa-temperature-low" },
  { icon: "fas fa-vote-yea" },
  { icon: "fas fa-water" },
  { icon: "fas fa-baby" },
  { icon: "fas fa-baby-carriage" },
  { icon: "fas fa-biohazard" },
  { icon: "fas fa-blog" },
  { icon: "fas fa-calendar-day" },
  { icon: "fas fa-calendar-week" },
  { icon: "fas fa-candy-cane" },
  { icon: "fas fa-carrot" },
  { icon: "fas fa-cash-register" },
  { icon: "fas fa-compress-arrows-alt" },
  { icon: "fas fa-dumpster" },
  { icon: "fas fa-dumpster-fire" },
  { icon: "fas fa-ethernet" },
  { icon: "fas fa-gifts" },
  { icon: "fas fa-glass-cheers" },
  { icon: "fas fa-glass-whiskey" },
  { icon: "fas fa-globe-europe" },
  { icon: "fas fa-grip-lines" },
  { icon: "fas fa-grip-lines-vertical" },
  { icon: "fas fa-guitar" },
  { icon: "fas fa-heart-broken" },
  { icon: "fas fa-holly-berry" },
  { icon: "fas fa-horse-head" },
  { icon: "fas fa-icicles" },
  { icon: "fas fa-igloo" },
  { icon: "fas fa-mitten" },
  { icon: "fas fa-mug-hot" },
  { icon: "fas fa-radiation" },
  { icon: "fas fa-radiation-alt" },
  { icon: "fas fa-restroom" },
  { icon: "fas fa-satellite" },
  { icon: "fas fa-satellite-dish" },
  { icon: "fas fa-sd-card" },
  { icon: "fas fa-sim-card" },
  { icon: "fas fa-skating" },
  { icon: "fas fa-skiing" },
  { icon: "fas fa-skiing-nordic" },
  { icon: "fas fa-sleigh" },
  { icon: "fas fa-sms" },
  { icon: "fas fa-snowboarding" },
  { icon: "fas fa-snowman" },
  { icon: "fas fa-snowplow" },
  { icon: "fas fa-tenge" },
  { icon: "fas fa-toilet" },
  { icon: "fas fa-tools" },
  { icon: "fas fa-tram" },
  { icon: "fas fa-fire-alt" },
  { icon: "fas fa-bacon" },
  { icon: "fas fa-book-medical" },
  { icon: "fas fa-bread-slice" },
  { icon: "fas fa-cheese" },
  { icon: "fas fa-clinic-medical" },
  { icon: "fas fa-comment-medical" },
  { icon: "fas fa-crutch" },
  { icon: "fas fa-egg" },
  { icon: "fas fa-hamburger" },
  { icon: "fas fa-hand-middle-finger" },
  { icon: "fas fa-hard-hat" },
  { icon: "fas fa-hotdog" },
  { icon: "fas fa-ice-cream" },
  { icon: "fas fa-laptop-medical" },
  { icon: "fas fa-pager" },
  { icon: "fas fa-pepper-hot" },
  { icon: "fas fa-pizza-slice" },
  { icon: "fas fa-trash-restore" },
  { icon: "fas fa-trash-restore-alt" },
  { icon: "fas fa-user-nurse" },
  { icon: "fas fa-wave-square" },
  { icon: "fas fa-biking" },
  { icon: "fas fa-border-all" },
  { icon: "fas fa-border-none" },
  { icon: "fas fa-border-style" },
  { icon: "fas fa-fan" },
  { icon: "fas fa-icons" },
  { icon: "fas fa-phone-alt" },
  { icon: "fas fa-phone-square-alt" },
  { icon: "fas fa-photo-video" },
  { icon: "fas fa-remove-format" },
  { icon: "fas fa-sort-alpha-down-alt" },
  { icon: "fas fa-sort-alpha-up-alt" },
  { icon: "fas fa-sort-amount-down-alt" },
  { icon: "fas fa-sort-amount-up-alt" },
  { icon: "fas fa-sort-numeric-down-alt" },
  { icon: "fas fa-sor-tnumeric-up-alt" },
  { icon: "fas fa-spell-check" },
  { icon: "fa fa-voicemail" },
];

// Array of corresponding unicode codes (hex values)
export const iconsNums = [
  { icon: "f000" },
  { icon: "f001" },
  { icon: "f002" },
  { icon: "f004" },
  { icon: "f005" },
  { icon: "f007" },
  { icon: "f008" },
  { icon: "f009" },
  { icon: "f00a" },
  { icon: "f00b" },
  { icon: "f00c" },
  { icon: "f00d" },
  { icon: "f00e" },
  { icon: "f010" },
  { icon: "f011" },
  { icon: "f012" },
  { icon: "f013" },
  { icon: "f015" },
  { icon: "f017" },
  { icon: "f018" },
  { icon: "f019" },
  { icon: "f01c" },
  { icon: "f01e" },
  { icon: "f021" },
  { icon: "f022" },
  { icon: "f023" },
  { icon: "f024" },
  { icon: "f025" },
  { icon: "f026" },
  { icon: "f027" },
  { icon: "f028" },
  { icon: "f029" },
  { icon: "f02a" },
  { icon: "f02b" },
  { icon: "f02c" },
  { icon: "f02d" },
  { icon: "f02e" },
  { icon: "f02f" },
  { icon: "f030" },
  { icon: "f031" },
  { icon: "f032" },
  { icon: "f033" },
  { icon: "f034" },
  { icon: "f035" },
  { icon: "f036" },
  { icon: "f037" },
  { icon: "f038" },
  { icon: "f039" },
  { icon: "f03a" },
  { icon: "f03b" },
  { icon: "f03c" },
  { icon: "f03d" },
  { icon: "f03e" },
  { icon: "f041" },
  { icon: "f042" },
  { icon: "f043" },
  { icon: "f044" },
  { icon: "f048" },
  { icon: "f049" },
  { icon: "f04a" },
  { icon: "f04b" },
  { icon: "f04c" },
  { icon: "f04d" },
  { icon: "f04e" },
  { icon: "f050" },
  { icon: "f051" },
  { icon: "f052" },
  { icon: "f053" },
  { icon: "f054" },
  { icon: "f055" },
  { icon: "f056" },
  { icon: "f057" },
  { icon: "f058" },
  { icon: "f059" },
  { icon: "f05a" },
  { icon: "f05b" },
  { icon: "f05e" },
  { icon: "f060" },
  { icon: "f061" },
  { icon: "f062" },
  { icon: "f063" },
  { icon: "f064" },
  { icon: "f065" },
  { icon: "f066" },
  { icon: "f067" },
  { icon: "f068" },
  { icon: "f069" },
  { icon: "f06a" },
  { icon: "f06b" },
  { icon: "f06c" },
  { icon: "f06d" },
  { icon: "f06e" },
  { icon: "f070" },
  { icon: "f071" },
  { icon: "f072" },
  { icon: "f073" },
  { icon: "f074" },
  { icon: "f075" },
  { icon: "f076" },
  { icon: "f077" },
  { icon: "f078" },
  { icon: "f079" },
  { icon: "f07a" },
  { icon: "f07b" },
  { icon: "f07c" },
  { icon: "f080" },
  { icon: "f083" },
  { icon: "f084" },
  { icon: "f085" },
  { icon: "f086" },
  { icon: "f089" },
  { icon: "f08d" },
  { icon: "f091" },
  { icon: "f093" },
  { icon: "f094" },
  { icon: "f095" },
  { icon: "f098" },
  { icon: "f09c" },
  { icon: "f09d" },
  { icon: "f09e" },
  { icon: "f0a0" },
  { icon: "f0a1" },
  { icon: "f0a3" },
  { icon: "f0a4" },
  { icon: "f0a5" },
  { icon: "f0a6" },
  { icon: "f0a7" },
  { icon: "f0a8" },
  { icon: "f0a9" },
  { icon: "f0aa" },
  { icon: "f0ab" },
  { icon: "f0ac" },
  { icon: "f0ad" },
  { icon: "f0ae" },
  { icon: "f0b0" },
  { icon: "f0b1" },
  { icon: "f0b2" },
  { icon: "f0c0" },
  { icon: "f0c1" },
  { icon: "f0c2" },
  { icon: "f0c3" },
  { icon: "f0c4" },
  { icon: "f0c5" },
  { icon: "f0c6" },
  { icon: "f0c7" },
  { icon: "f0c8" },
  { icon: "f0c9" },
  { icon: "f0ca" },
  { icon: "f0cb" },
  { icon: "f0cc" },
  { icon: "f0cd" },
  { icon: "f0ce" },
  { icon: "f0d0" },
  { icon: "f0d1" },
  { icon: "f0d6" },
  { icon: "f0d7" },
  { icon: "f0d8" },
  { icon: "f0d9" },
  { icon: "f0da" },
  { icon: "f0db" },
  { icon: "f0dc" },
  { icon: "f0dd" },
  { icon: "f0de" },
  { icon: "f0e0" },
  { icon: "f0e2" },
  { icon: "f0e3" },
  { icon: "f0e7" },
  { icon: "f0e8" },
  { icon: "f0e9" },
  { icon: "f0ea" },
  { icon: "f0eb" },
  { icon: "f0f0" },
  { icon: "f0f1" },
  { icon: "f0f2" },
  { icon: "f0f3" },
  { icon: "f0f4" },
  { icon: "f0f8" },
  { icon: "f0f9" },
  { icon: "f0fa" },
  { icon: "f0fb" },
  { icon: "f0fc" },
  { icon: "f0fd" },
  { icon: "f0fe" },
  { icon: "f100" },
  { icon: "f101" },
  { icon: "f102" },
  { icon: "f103" },
  { icon: "f104" },
  { icon: "f105" },
  { icon: "f106" },
  { icon: "f107" },
  { icon: "f108" },
  { icon: "f109" },
  { icon: "f10a" },
  { icon: "f10b" },
  { icon: "f10d" },
  { icon: "f10e" },
  { icon: "f110" },
  { icon: "f111" },
  { icon: "f118" },
  { icon: "f119" },
  { icon: "f11a" },
  { icon: "f11b" },
  { icon: "f11c" },
  { icon: "f11e" },
  { icon: "f120" },
  { icon: "f121" },
  { icon: "f122" },
  { icon: "f124" },
  { icon: "f125" },
  { icon: "f126" },
  { icon: "f127" },
  { icon: "f128" },
  { icon: "f129" },
  { icon: "f12a" },
  { icon: "f12b" },
  { icon: "f12c" },
  { icon: "f12d" },
  { icon: "f12e" },
  { icon: "f130" },
  { icon: "f131" },
  { icon: "f133" },
  { icon: "f134" },
  { icon: "f135" },
  { icon: "f137" },
  { icon: "f138" },
  { icon: "f139" },
  { icon: "f13a" },
  { icon: "f13d" },
  { icon: "f13e" },
  { icon: "f140" },
  { icon: "f141" },
  { icon: "f142" },
  { icon: "f143" },
  { icon: "f144" },
  { icon: "f146" },
  { icon: "f14a" },
  { icon: "f14b" },
  { icon: "f14d" },
  { icon: "f14e" },
  { icon: "f150" },
  { icon: "f151" },
  { icon: "f152" },
  { icon: "f153" },
  { icon: "f154" },
  { icon: "f155" },
  { icon: "f156" },
  { icon: "f157" },
  { icon: "f158" },
  { icon: "f159" },
  { icon: "f15b" },
  { icon: "f15c" },
  { icon: "f15d" },
  { icon: "f15e" },
  { icon: "f160" },
  { icon: "f161" },
  { icon: "f162" },
  { icon: "f163" },
  { icon: "f164" },
  { icon: "f165" },
  { icon: "f182" },
  { icon: "f183" },
  { icon: "f185" },
  { icon: "f186" },
  { icon: "f187" },
  { icon: "f188" },
  { icon: "f191" },
  { icon: "f192" },
  { icon: "f193" },
  { icon: "f195" },
  { icon: "f197" },
  { icon: "f199" },
  { icon: "f19c" },
  { icon: "f19d" },
  { icon: "f1ab" },
  { icon: "f1ac" },
  { icon: "f1ad" },
  { icon: "f1ae" },
  { icon: "f1b0" },
  { icon: "f1b2" },
  { icon: "f1b3" },
  { icon: "f1b8" },
  { icon: "f1b9" },
  { icon: "f1ba" },
  { icon: "f1bb" },
  { icon: "f1c0" },
  { icon: "f1c1" },
  { icon: "f1c2" },
  { icon: "f1c3" },
  { icon: "f1c4" },
  { icon: "f1c5" },
  { icon: "f1c6" },
  { icon: "f1c7" },
  { icon: "f1c8" },
  { icon: "f1c9" },
  { icon: "f1cd" },
  { icon: "f1ce" },
  { icon: "f1d8" },
  { icon: "f1da" },
  { icon: "f1dc" },
  { icon: "f1dd" },
  { icon: "f1de" },
  { icon: "f1e0" },
  { icon: "f1e1" },
  { icon: "f1e2" },
  { icon: "f1e3" },
  { icon: "f1e4" },
  { icon: "f1e5" },
  { icon: "f1e6" },
  { icon: "f1ea" },
  { icon: "f1eb" },
  { icon: "f1ec" },
  { icon: "f1f6" },
  { icon: "f1f8" },
  { icon: "f1f9" },
  { icon: "f1fa" },
  { icon: "f1fb" },
  { icon: "f1fc" },
  { icon: "f1fd" },
  { icon: "f1fe" },
  { icon: "f200" },
  { icon: "f201" },
  { icon: "f204" },
  { icon: "f205" },
  { icon: "f206" },
  { icon: "f207" },
  { icon: "f20a" },
  { icon: "f20b" },
  { icon: "f217" },
  { icon: "f218" },
  { icon: "f21a" },
  { icon: "f21b" },
  { icon: "f21c" },
  { icon: "f21d" },
  { icon: "f21e" },
  { icon: "f221" },
  { icon: "f222" },
  { icon: "f223" },
  { icon: "f224" },
  { icon: "f225" },
  { icon: "f226" },
  { icon: "f227" },
  { icon: "f228" },
  { icon: "f229" },
  { icon: "f22a" },
  { icon: "f22b" },
  { icon: "f22c" },
  { icon: "f22d" },
  { icon: "f233" },
  { icon: "f234" },
  { icon: "f235" },
  { icon: "f236" },
  { icon: "f238" },
  { icon: "f239" },
  { icon: "f240" },
  { icon: "f241" },
  { icon: "f242" },
  { icon: "f243" },
  { icon: "f244" },
  { icon: "f245" },
  { icon: "f246" },
  { icon: "f247" },
  { icon: "f248" },
  { icon: "f249" },
  { icon: "f24d" },
  { icon: "f24e" },
  { icon: "f251" },
  { icon: "f252" },
  { icon: "f253" },
  { icon: "f254" },
  { icon: "f255" },
  { icon: "f256" },
  { icon: "f257" },
  { icon: "f258" },
  { icon: "f259" },
  { icon: "f25a" },
  { icon: "f25b" },
  { icon: "f25c" },
  { icon: "f25d" },
  { icon: "f26c" },
  { icon: "f271" },
  { icon: "f272" },
  { icon: "f273" },
  { icon: "f274" },
  { icon: "f275" },
  { icon: "f276" },
  { icon: "f277" },
  { icon: "f279" },
  { icon: "f27a" },
  { icon: "f28b" },
  { icon: "f28d" },
  { icon: "f290" },
  { icon: "f291" },
  { icon: "f292" },
  { icon: "f295" },
  { icon: "f29a" },
  { icon: "f29d" },
  { icon: "f29e" },
  { icon: "f2a0" },
  { icon: "f2a1" },
  { icon: "f2a2" },
  { icon: "f2a3" },
  { icon: "f2a4" },
  { icon: "f2a7" },
  { icon: "f2a8" },
  { icon: "f2b5" },
  { icon: "f2b6" },
  { icon: "f2b9" },
  { icon: "f2bb" },
  { icon: "f2bd" },
  { icon: "f2c1" },
  { icon: "f2c2" },
  { icon: "f2c7" },
  { icon: "f2c8" },
  { icon: "f2c9" },
  { icon: "f2ca" },
  { icon: "f2cb" },
  { icon: "f2cc" },
  { icon: "f2cd" },
  { icon: "f2ce" },
  { icon: "f2d0" },
  { icon: "f2d1" },
  { icon: "f2d2" },
  { icon: "f2db" },
  { icon: "f2dc" },
  { icon: "f2e5" },
  { icon: "f2e7" },
  { icon: "f2ea" },
  { icon: "f2ed" },
  { icon: "f2f1" },
  { icon: "f2f2" },
  { icon: "f2f5" },
  { icon: "f2f6" },
  { icon: "f2f9" },
  { icon: "f2fe" },
  { icon: "f302" },
  { icon: "f303" },
  { icon: "f304" },
  { icon: "f305" },
  { icon: "f309" },
  { icon: "f30a" },
  { icon: "f30b" },
  { icon: "f30c" },
  { icon: "f31e" },
  { icon: "f328" },
  { icon: "f337" },
  { icon: "f338" },
  { icon: "f358" },
  { icon: "f359" },
  { icon: "f35a" },
  { icon: "f35b" },
  { icon: "f35d" },
  { icon: "f360" },
  { icon: "f362" },
  { icon: "f381" },
  { icon: "f382" },
  { icon: "f3a5" },
  { icon: "f3be" },
  { icon: "f3bf" },
  { icon: "f3c1" },
  { icon: "f3c5" },
  { icon: "f3c9" },
  { icon: "f3cd" },
  { icon: "f3d1" },
  { icon: "f3dd" },
  { icon: "f3e0" },
  { icon: "f3e5" },
  { icon: "f3ed" },
  { icon: "f3fa" },
  { icon: "f3fd" },
  { icon: "f3ff" },
  { icon: "f406" },
  { icon: "f410" },
  { icon: "f433" },
  { icon: "f434" },
  { icon: "f436" },
  { icon: "f439" },
  { icon: "f43a" },
  { icon: "f43c" },
  { icon: "f43f" },
  { icon: "f441" },
  { icon: "f443" },
  { icon: "f445" },
  { icon: "f447" },
  { icon: "f44b" },
  { icon: "f44e" },
  { icon: "f450" },
  { icon: "f453" },
  { icon: "f458" },
  { icon: "f45c" },
  { icon: "f45d" },
  { icon: "f45f" },
  { icon: "f461" },
  { icon: "f462" },
  { icon: "f466" },
  { icon: "f468" },
  { icon: "f469" },
  { icon: "f46a" },
  { icon: "f46b" },
  { icon: "f46c" },
  { icon: "f46d" },
  { icon: "f470" },
  { icon: "f471" },
  { icon: "f472" },
  { icon: "f474" },
  { icon: "f477" },
  { icon: "f478" },
  { icon: "f479" },
  { icon: "f47d" },
  { icon: "f47e" },
  { icon: "f47f" },
  { icon: "f481" },
  { icon: "f482" },
  { icon: "f484" },
  { icon: "f485" },
  { icon: "f486" },
  { icon: "f487" },
  { icon: "f48b" },
  { icon: "f48d" },
  { icon: "f48e" },
  { icon: "f490" },
  { icon: "f491" },
  { icon: "f492" },
  { icon: "f493" },
  { icon: "f494" },
  { icon: "f496" },
  { icon: "f497" },
  { icon: "f49e" },
  { icon: "f4ad" },
  { icon: "f4b3" },
  { icon: "f4b8" },
  { icon: "f4b9" },
  { icon: "f4ba" },
  { icon: "f4bd" },
  { icon: "f4be" },
  { icon: "f4c0" },
  { icon: "f4c2" },
  { icon: "f4c4" },
  { icon: "f4cd" },
  { icon: "f4ce" },
  { icon: "f4d3" },
  { icon: "f4d6" },
  { icon: "f4d7" },
  { icon: "f4d8" },
  { icon: "f4d9" },
  { icon: "f4da" },
  { icon: "f4db" },
  { icon: "f4de" },
  { icon: "f4df" },
  { icon: "f4e2" },
  { icon: "f4e3" },
  { icon: "f4fa" },
  { icon: "f4fb" },
  { icon: "f4fc" },
  { icon: "f4fd" },
  { icon: "f4fe" },
  { icon: "f4ff" },
  { icon: "f500" },
  { icon: "f501" },
  { icon: "f502" },
  { icon: "f503" },
  { icon: "f504" },
  { icon: "f505" },
  { icon: "f506" },
  { icon: "f507" },
  { icon: "f508" },
  { icon: "f509" },
  { icon: "f515" },
  { icon: "f516" },
  { icon: "f517" },
  { icon: "f518" },
  { icon: "f519" },
  { icon: "f51a" },
  { icon: "f51b" },
  { icon: "f51c" },
  { icon: "f51d" },
  { icon: "f51e" },
  { icon: "f51f" },
  { icon: "f520" },
  { icon: "f521" },
  { icon: "f522" },
  { icon: "f523" },
  { icon: "f524" },
  { icon: "f525" },
  { icon: "f526" },
  { icon: "f527" },
  { icon: "f528" },
  { icon: "f529" },
  { icon: "f52a" },
  { icon: "f52b" },
  { icon: "f52c" },
  { icon: "f52d" },
  { icon: "f52e" },
  { icon: "f52f" },
  { icon: "f530" },
  { icon: "f531" },
  { icon: "f532" },
  { icon: "f533" },
  { icon: "f534" },
  { icon: "f535" },
  { icon: "f536" },
  { icon: "f537" },
  { icon: "f538" },
  { icon: "f539" },
  { icon: "f53a" },
  { icon: "f53b" },
  { icon: "f53c" },
  { icon: "f53d" },
  { icon: "f53e" },
  { icon: "f53f" },
  { icon: "f540" },
  { icon: "f541" },
  { icon: "f542" },
  { icon: "f543" },
  { icon: "f544" },
  { icon: "f545" },
  { icon: "f546" },
  { icon: "f547" },
  { icon: "f548" },
  { icon: "f549" },
  { icon: "f54a" },
  { icon: "f54b" },
  { icon: "f54c" },
  { icon: "f54d" },
  { icon: "f54e" },
  { icon: "f54f" },
  { icon: "f550" },
  { icon: "f551" },
  { icon: "f552" },
  { icon: "f553" },
  { icon: "f554" },
  { icon: "f555" },
  { icon: "f556" },
  { icon: "f557" },
  { icon: "f558" },
  { icon: "f559" },
  { icon: "f55a" },
  { icon: "f55b" },
  { icon: "f55c" },
  { icon: "f55d" },
  { icon: "f55e" },
  { icon: "f55f" },
  { icon: "f560" },
  { icon: "f561" },
  { icon: "f562" },
  { icon: "f563" },
  { icon: "f564" },
  { icon: "f565" },
  { icon: "f566" },
  { icon: "f567" },
  { icon: "f568" },
  { icon: "f569" },
  { icon: "f56a" },
  { icon: "f56b" },
  { icon: "f56c" },
  { icon: "f56d" },
  { icon: "f56e" },
  { icon: "f56f" },
  { icon: "f570" },
  { icon: "f571" },
  { icon: "f572" },
  { icon: "f573" },
  { icon: "f574" },
  { icon: "f575" },
  { icon: "f576" },
  { icon: "f577" },
  { icon: "f578" },
  { icon: "f579" },
  { icon: "f57a" },
  { icon: "f57b" },
  { icon: "f57c" },
  { icon: "f57d" },
  { icon: "f57e" },
  { icon: "f57f" },
  { icon: "f580" },
  { icon: "f581" },
  { icon: "f582" },
  { icon: "f583" },
  { icon: "f584" },
  { icon: "f585" },
  { icon: "f586" },
  { icon: "f587" },
  { icon: "f588" },
  { icon: "f589" },
  { icon: "f58a" },
  { icon: "f58b" },
  { icon: "f58c" },
  { icon: "f58d" },
  { icon: "f58e" },
  { icon: "f58f" },
  { icon: "f590" },
  { icon: "f591" },
  { icon: "f593" },
  { icon: "f594" },
  { icon: "f595" },
  { icon: "f596" },
  { icon: "f597" },
  { icon: "f598" },
  { icon: "f599" },
  { icon: "f59a" },
  { icon: "f59b" },
  { icon: "f59c" },
  { icon: "f59d" },
  { icon: "f59f" },
  { icon: "f5a0" },
  { icon: "f5a1" },
  { icon: "f5a2" },
  { icon: "f5a4" },
  { icon: "f5a5" },
  { icon: "f5a6" },
  { icon: "f5a7" },
  { icon: "f5aa" },
  { icon: "f5ab" },
  { icon: "f5ac" },
  { icon: "f5ad" },
  { icon: "f5ae" },
  { icon: "f5af" },
  { icon: "f5b0" },
  { icon: "f5b1" },
  { icon: "f5b3" },
  { icon: "f5b4" },
  { icon: "f5b6" },
  { icon: "f5b7" },
  { icon: "f5b8" },
  { icon: "f5ba" },
  { icon: "f5bb" },
  { icon: "f5bc" },
  { icon: "f5bd" },
  { icon: "f5bf" },
  { icon: "f5c0" },
  { icon: "f5c1" },
  { icon: "f5c2" },
  { icon: "f5c3" },
  { icon: "f5c4" },
  { icon: "f5c5" },
  { icon: "f5c7" },
  { icon: "f5c8" },
  { icon: "f5c9" },
  { icon: "f5ca" },
  { icon: "f5cb" },
  { icon: "f5cd" },
  { icon: "f5ce" },
  { icon: "f5d0" },
  { icon: "f5d1" },
  { icon: "f5d2" },
  { icon: "f5d7" },
  { icon: "f5da" },
  { icon: "f5dc" },
  { icon: "f5de" },
  { icon: "f5df" },
  { icon: "f5e1" },
  { icon: "f5e4" },
  { icon: "f5e7" },
  { icon: "f5eb" },
  { icon: "f5ee" },
  { icon: "f5fc" },
  { icon: "f5fd" },
  { icon: "f610" },
  { icon: "f613" },
  { icon: "f619" },
  { icon: "f61f" },
  { icon: "f621" },
  { icon: "f62e" },
  { icon: "f62f" },
  { icon: "f630" },
  { icon: "f637" },
  { icon: "f63b" },
  { icon: "f63c" },
  { icon: "f641" },
  { icon: "f644" },
  { icon: "f647" },
  { icon: "f64a" },
  { icon: "f64f" },
  { icon: "f651" },
  { icon: "f653" },
  { icon: "f654" },
  { icon: "f655" },
  { icon: "f658" },
  { icon: "f65d" },
  { icon: "f65e" },
  { icon: "f662" },
  { icon: "f664" },
  { icon: "f665" },
  { icon: "f666" },
  { icon: "f669" },
  { icon: "f66a" },
  { icon: "f66b" },
  { icon: "f66d" },
  { icon: "f66f" },
  { icon: "f674" },
  { icon: "f676" },
  { icon: "f678" },
  { icon: "f679" },
  { icon: "f67b" },
  { icon: "f67c" },
  { icon: "f67f" },
  { icon: "f681" },
  { icon: "f682" },
  { icon: "f683" },
  { icon: "f684" },
  { icon: "f687" },
  { icon: "f688" },
  { icon: "f689" },
  { icon: "f696" },
  { icon: "f698" },
  { icon: "f699" },
  { icon: "f69a" },
  { icon: "f69b" },
  { icon: "f6a0" },
  { icon: "f6a1" },
  { icon: "f6a7" },
  { icon: "f6a9" },
  { icon: "f6ad" },
  { icon: "f6b6" },
  { icon: "f6b7" },
  { icon: "f6bb" },
  { icon: "f6be" },
  { icon: "f6c0" },
  { icon: "f6c3" },
  { icon: "f6c4" },
  { icon: "f6cf" },
  { icon: "f6d1" },
  { icon: "f6d3" },
  { icon: "f6d5" },
  { icon: "f6d7" },
  { icon: "f6d9" },
  { icon: "f6dd" },
  { icon: "f6de" },
  { icon: "f6e2" },
  { icon: "f6e3" },
  { icon: "f6e6" },
  { icon: "f6e8" },
  { icon: "f6ec" },
  { icon: "f6ed" },
  { icon: "f6f0" },
  { icon: "f6f1" },
  { icon: "f6f2" },
  { icon: "f6fa" },
  { icon: "f6fc" },
  { icon: "f6ff" },
  { icon: "f700" },
  { icon: "f70b" },
  { icon: "f70c" },
  { icon: "f70e" },
  { icon: "f714" },
  { icon: "f715" },
  { icon: "f717" },
  { icon: "f71e" },
  { icon: "f722" },
  { icon: "f728" },
  { icon: "f729" },
  { icon: "f72e" },
  { icon: "f72f" },
  { icon: "f73b" },
  { icon: "f73c" },
  { icon: "f73d" },
  { icon: "f740" },
  { icon: "f743" },
  { icon: "f747" },
  { icon: "f74d" },
  { icon: "f753" },
  { icon: "f756" },
  { icon: "f75a" },
  { icon: "f75b" },
  { icon: "f75e" },
  { icon: "f75f" },
  { icon: "f769" },
  { icon: "f76b" },
  { icon: "f772" },
  { icon: "f773" },
  { icon: "f77c" },
  { icon: "f77d" },
  { icon: "f780" },
  { icon: "f781" },
  { icon: "f783" },
  { icon: "f784" },
  { icon: "f786" },
  { icon: "f787" },
  { icon: "f788" },
  { icon: "f78c" },
  { icon: "f793" },
  { icon: "f794" },
  { icon: "f796" },
  { icon: "f79c" },
  { icon: "f79f" },
  { icon: "f7a0" },
  { icon: "f7a2" },
  { icon: "f7a4" },
  { icon: "f7a5" },
  { icon: "f7a6" },
  { icon: "f7a9" },
  { icon: "f7aa" },
  { icon: "f7ab" },
  { icon: "f7ad" },
  { icon: "f7ae" },
  { icon: "f7b5" },
  { icon: "f7b6" },
  { icon: "f7b9" },
  { icon: "f7ba" },
  { icon: "f7bd" },
  { icon: "f7bf" },
  { icon: "f7c0" },
  { icon: "f7c2" },
  { icon: "f7c4" },
  { icon: "f7c5" },
  { icon: "f7c9" },
  { icon: "f7ca" },
  { icon: "f7cc" },
  { icon: "f7cd" },
  { icon: "f7ce" },
  { icon: "f7d0" },
  { icon: "f7d2" },
  { icon: "f7d7" },
  { icon: "f7d8" },
  { icon: "f7d9" },
  { icon: "f7da" },
  { icon: "f7e4" },
  { icon: "f7e5" },
  { icon: "f7e6" },
  { icon: "f7ec" },
  { icon: "f7ef" },
  { icon: "f7f2" },
  { icon: "f7f5" },
  { icon: "f7f7" },
  { icon: "f7fb" },
  { icon: "f805" },
  { icon: "f806" },
  { icon: "f807" },
  { icon: "f80f" },
  { icon: "f810" },
  { icon: "f812" },
  { icon: "f815" },
  { icon: "f816" },
  { icon: "f818" },
  { icon: "f829" },
  { icon: "f82a" },
  { icon: "f82f" },
  { icon: "f83e" },
  { icon: "f84a" },
  { icon: "f84c" },
  { icon: "f850" },
  { icon: "f853" },
  { icon: "f863" },
  { icon: "f86d" },
  { icon: "f879" },
  { icon: "f87b" },
  { icon: "f87c" },
  { icon: "f87d" },
  { icon: "f881" },
  { icon: "f882" },
  { icon: "f884" },
  { icon: "f885" },
  { icon: "f886" },
  { icon: "f887" },
  { icon: "f891" },
  { icon: "f897" },
];
